import {
  fetchAddFlatTourBooking,
  TAddFlatTourBookingRequest,
  TAddFlatTourBookingResponse,
} from '../../../shared/repositories/newbuilding-flat-tour-booking/v1/add-flat-tour-booking';
import { getNewbuildingId } from '../../../shared/selectors/newbuilding';
import { transformUserBookingStatus } from '../../../shared/mappers/transformUserBookingStatus';
import { setFlatViewOrder } from '../../../shared/slices/newbuildingReducer';
import { toggleFlatViewOrderBanner } from '../../../shared/slices/flatViewOrder';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { IThunkApi } from '../../../shared/types/redux';

type IAddFlatTourBookingParams = Pick<TAddFlatTourBookingRequest, 'phone' | 'tourTime' | 'fullName' | 'builderUserId'>;

export const addFlatTourBooking = createAsyncThunk<void, IAddFlatTourBookingParams, IThunkApi>(
  'flatTourBooking/addFlatTourBooking',
  async (params, thunkApi) => {
    const {
      dispatch,
      getState,
      extra: { httpApi, logger },
    } = thunkApi;

    try {
      const newbuildingId = getNewbuildingId(getState());

      const response: TAddFlatTourBookingResponse = await fetchAddFlatTourBooking({
        httpApi,
        parameters: {
          ...params,
          newbuildingId,
        },
        config: {
          requestConfig: {
            headers: [['Content-Type', 'application/json']],
          },
        },
      });

      if (response.statusCode !== 200) {
        throw response.response.message;
      }

      const flatViewOrder = transformUserBookingStatus(response.response.userBookingStatus);
      dispatch(setFlatViewOrder(flatViewOrder));
      dispatch(toggleFlatViewOrderBanner(true));
    } catch (error) {
      logger.error(error, {
        domain: 'addFlatTourBooking',
      });
      throw error;
    }
  },
);
